import { TravelArrangementEnums } from './types';

export const arrangementVisibilityConfig = [
  {
    type: TravelArrangementEnums.NO_COMPENSATION,
    translationKey: 'travelArrangements.arrangementOptions.NO_COMPENSATION',
    hiddenFields: ['LocationSection', 'DistanceAndAmountSection'],
    schema: 'NoCompensationSchema'
  },
  {
    type: TravelArrangementEnums.VARIABLE_BASED_ON_ADDRESS,
    translationKey:
      'travelArrangements.arrangementOptions.VARIABLE_BASED_ON_ADDRESS',
    hiddenFields: ['distanceAndAmount.amount'],
    schema: 'VariableBasedOnAddressSchema'
  },
  {
    type: TravelArrangementEnums.VARIABLE_BASED_ON_POSTAL_CODE,
    translationKey:
      'travelArrangements.arrangementOptions.VARIABLE_BASED_ON_POSTAL_CODE',
    hiddenFields: ['distanceAndAmount.amount', 'location.cityAndStreet'],
    schema: 'VariableBasedOnPostalCodeSchema'
  },
  {
    type: TravelArrangementEnums.VARIABLE_BASED_ON_DISTANCE,
    translationKey:
      'travelArrangements.arrangementOptions.VARIABLE_BASED_ON_DISTANCE',
    hiddenFields: ['LocationSection', 'distanceAndAmount.amount'],
    schema: 'VariableBasedOnDistanceSchema'
  },
  {
    type: TravelArrangementEnums.VARIABLE_BASED_ON_DISTANCE_IN_SERVICE,
    translationKey:
      'travelArrangements.arrangementOptions.VARIABLE_BASED_ON_DISTANCE_IN_SERVICE',
    hiddenFields: ['LocationSection', 'DistanceAndAmountSection'],
    schema: 'VariableBasedOnDistanceInServiceSchema'
  },
  {
    type: TravelArrangementEnums.FIXED_AMOUNT,
    translationKey: 'travelArrangements.arrangementOptions.FIXED_AMOUNT',
    hiddenFields: ['LocationSection'],
    schema: 'FixedAmountSchema'
  }
];

export function replaceUrlParams(
  url: string,
  params: Record<string, string | number | undefined>
) {
  return url.replace(/:([A-Za-z0-9]+)/g, (_, key) => {
    // If the key has a value, replace; otherwise leave it as is
    const value = params[key];
    return value != null ? String(value) : `:${key}`;
  });
}
